export default "__VITE_ASSET__BFa7QJc6__"